// extracted by mini-css-extract-plugin
export default {"icon":"y_PwQ1mZSU","icon_stalled":"U6UFfslAGc"};